<script>
import Icon from '../../Icon/Icon.vue';

export default {
  components: { Icon },
  props: {
    questionData: {
      type: Object,
      default: () => {},
    },
    answer: {
      type: Number,
      default: null,
    },
    size: {
      type: Number,
      default: 24,
    },
  },
  data() {
    return {
      steps: this.answer,
    };
  },
  computed: {
    stars() {
      let options = [];
      for (let i = 1; i <= this.questionData.max_scale; i++) {
        options = options.concat(i);
      }
      return options;
    },
  },
  methods: {
    handleAnswerChange(value) {
      if (this.steps === value) {
        return this.steps -= 1;
      }
      this.steps = value;

      return this.$emit('change', value);
    },
  },
};
</script>

<template>
  <div class="cxm-Rating">
    <div
      v-for="star in stars"
      :key="star"
      class="cxm-Rating-Star"
      :class="{ '-selected': steps >= star }"
    >
      <Icon
        name="star"
        :size="size"
        :handle-click="() => handleAnswerChange(star)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cxm-Rating {
  display: flex;
  gap: var(--track-spacing-bg);
}
.cxm-Rating-Star {
  transition: all ease 0.2s;
  &:hover {
    transform: scale(1.2);
    cursor: pointer;
    svg {
      fill: #ffd21f;
      stroke: #ffd21f;
    }
  }
  &.-selected {
    svg {
      fill: #ffd21f;
      stroke: #ffd21f;
    }
    &:hover {
      transform: scale(0.9);
    }
  }
}
</style>
